export default __webpack_public_path__ + "b4f4ed8827310a4642571c251332048d.png";